import React, { useEffect } from 'react';
import ListItem from '../components/ListItem';
import ServicosAbraCasa from '../components/ServicosAbraCasa';
import ServicosTeaser from '../components/ServicosTeaser';
import styles from './Lista.module.css';
import logoCasa from "../images/casa-logo.svg";

// Oferta de serviços desativada nesta tela por enquanto. Mude para `true` para exibir.
const SHOW_SERVICOS = false;

function Lista() {
  const storage = localStorage.getItem('orders');
  const parsedOrders = storage ? JSON.parse(storage) : null;

  const backToHome = () => {
    localStorage.clear();
    window.location.href = '/';
  };

  useEffect(() => {
    if (!parsedOrders) return backToHome();

    if (localStorage.getItem('loggedDateTime')) {
      const dateDifference = DateDifference(localStorage.getItem('loggedDateTime'));

      if (dateDifference && dateDifference >= 120) backToHome();
    }
  }, [parsedOrders]);

  const DateDifference = (dateInput) => {
    const inputDate = new Date(dateInput);
    const now = new Date();

    const diffInMs = now - inputDate;
    const diffInMinutes = Math.floor(diffInMs / 60000);
    return diffInMinutes;
  };

  return (
    <div className={styles.pageWrapper}>
      <header className={styles.header}>
        <div className={styles.headerContent}>
          <a
            href="https://www.abracasa.com.br/"
            target="_blank"
            rel="noreferrer noopener"
            className={styles.logoLink}
          >
            <img className={styles.headerLogo} src={logoCasa} alt="Abra Casa" />
          </a>
        </div>
        <button 
          className={styles.backButton} 
          onClick={() => { backToHome() }}
          aria-label="Voltar para página inicial"
        >
          <svg 
            xmlns="http://www.w3.org/2000/svg" 
            width="20" 
            height="20" 
            viewBox="0 0 24 24" 
            fill="none" 
            stroke="currentColor" 
            strokeWidth="2" 
            strokeLinecap="round" 
            strokeLinejoin="round"
          >
            <path d="m9 6-6 6 6 6" />
            <path d="M3 12h14" />
            <path d="M21 19V5" />
          </svg>
          <span className={styles.backButtonText}>Voltar</span>
        </button>
      </header>
      <div className={styles.pageContainer}>
        <div className={styles.pageHeader}>
          <div className={styles.titleWrapper}>
            <h1 className={styles.pageTitle}>
              <span className={styles.titleIcon}>📋</span>
              Meus Pedidos
            </h1>
            <p className={styles.pageSubtitle}>
              {parsedOrders?.data?.length > 0 
                ? `${parsedOrders.data.length} ${parsedOrders.data.length === 1 ? 'pedido encontrado' : 'pedidos encontrados'}`
                : 'Nenhum pedido encontrado'}
            </p>
          </div>
        </div>
        {SHOW_SERVICOS && (
          <div className={styles.teaserWrapper}>
            <ServicosTeaser />
          </div>
        )}
        <div className={styles.listContainer}>
          {parsedOrders?.data?.map((item, index) => (
            <div 
              key={item?.identifier}
              className={styles.listItemWrapper}
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <ListItem
                {...item}
              />
            </div>
          ))}
        </div>
        {(!parsedOrders?.data || parsedOrders.data.length === 0) && (
          <div className={styles.emptyState}>
            <div className={styles.emptyIcon}>📭</div>
            <h2 className={styles.emptyTitle}>Nenhum pedido encontrado</h2>
            <p className={styles.emptyDescription}>
              Não encontramos pedidos associados ao seu documento.
            </p>
          </div>
        )}
        {SHOW_SERVICOS && (
          <div className={styles.servicosWrapper}>
            <ServicosAbraCasa context="lista" />
          </div>
        )}
      </div>
    </div>
  );
}

export default Lista; 